<template>
  <div class="pt-3 px-3 pb-1">
           
      <p v-if="contacts.length == 0" class="text-center">No links</p>

        <div v-else>

       <!--- Desktop --->
        <table class="table d-none d-md-table">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="15%">{{total}}</th>
                  <th class="text-center" width="20%">Browser</th>
                  <th class="pl-3" width="40%">Email</th>
                  <th class="pl-3" width="10%">Country</th>
                  <th class="first-right px-3" width="15%">Date</th>
                </tr>
              </thead>
              <tbody>
    <tr v-for="(contact, index) in contacts" :key="index">
      <td class="pl-3"><a :href="'http://ip-api.com/json/'+contact.ip" target="_blank" class="iplink">{{contact.ip}}</a></td>
      <td class="pl-3 agent"><span :title="contact.agent"><i :class="contact.agent_logo+' fa-2x logo'"></i></span></td>
      <td class="pl-3"><a :href="`/advertising?email=${contact.email}`" target="_blank">{{contact.email}}</a></td>
      <td class="pl-3"><img :src="'/images/flags/svg/'+contact.country_flag" class="country_flag" :title="contact.city+' - '+contact.country"></td>
      <td class="pl-3 text-nowrap"><timeago
                :datetime="contact.created_at"
                :auto-update="60"
                :title="formatDateMoment(contact.created_at)"></timeago></td>
    </tr>
              </tbody>
            </table>

        <!--- Mobile --->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Email • Date</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(contact, index) in contacts" :key="index">
  
        <td class="pl-2 text-center">
            <div><b>{{contact.email}}</b></div>
            <div><timeago
                  :datetime="contact.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(contact.created_at)"></timeago></div>
        </td>
      
            </tr>
          </tbody>
        </table>

        </div>
    </div>

</template>

<script>
export default {
  props: ['search_term'],

  watch: {
    search_term: function (val) {
      this.getContacts();
    }
  },

  data() {
    return {
      contacts: [],
      contactInfo: {},
      loading: false,
      total: 0,
    };
  },

  created() {
    this.getContacts();

    Echo.private("contacts")
      .listen("UpdateClicks", (event) => {
        this.getContacts();
      });

  },

  methods: {

    getContacts() {

      this.loading = true;

      axios
        .post('/contacts/email-clicks', {
          search_term: this.search_term
        })
        .then((response) => {
          this.contacts = response.data.clicks;
          this.total = response.data.total;
          this.loading = false;
        });
    },

  },
};
</script> 

<style scoped>
a.iplink { font-weight:normal !important; }
.logo { position: relative; top: 0px;}
td.agent { text-align: center; width:70px; }
td.source { text-align: center; width:60px; }
</style>